import React, {useEffect, useRef} from 'react';
import {Link, Head} from '@inertiajs/inertia-react';
import 'swiper/css';
import "swiper/css/pagination";
import Sponsor1 from '@/Components/Front/SVGS/Sponsor1';
import Member1 from '@/Components/Front/PNGS/member-1.jpg';

import Header from '@/Components/Front/Header';
import useLang from '@/Hooks/useLang';
import Text from '@/Components/Front/Text';
import Graph5 from "@/Components/Front/Graphs/Graph5";
import Rive, {Alignment, Fit, Layout} from 'rive-react'
import DemoCreateEls from "@/Components/Front/DemoCreateEls";
import Ratio from "@/Plugins/Ratio";
import Graph2 from "@/Components/Front/Graphs/Graph2";
import DarkPlanet from "@/Components/Front/PNGS/DarkPlanet.png";
import Step1 from "@/Components/Front/SVGS/Step1";
import Footer from "@/Components/Front/Footer";
import Zoom from 'react-reveal/Zoom';
import Fade from "react-reveal/Fade";
import Step2 from "@/Components/Front/SVGS/Step2";
import Step3 from "@/Components/Front/SVGS/Step3";
import LineaGraph from "@/Components/Front/SVGS/LineaGraph";
import LineaDb from "@/Components/Front/SVGS/LineaDb";
import LineaData from "@/Components/Front/SVGS/LineaData";
import Circle from "@/Components/Front/SVGS/Circle";
import Bar from "@/Components/Front/SVGS/Bar";
import VisibilitySensor from 'react-visibility-sensor';
import Graph3 from "@/Components/Front/Graphs/Graph3";
import Graph4 from "@/Components/Front/Graphs/Graph4";
import GraphColor from "@/Components/Front/Graphs/GraphColor";
import {Swiper, SwiperSlide} from "swiper/react";
import LineaPublication from "@/Components/Front/SVGS/LineaPublication";

import TeamFlat from "@/Components/Front/SVGS/TeamFlat";

import ArrowDown from "@/Components/Front/SVGS/ArrowDown";
import ScrollToTop from "react-scroll-to-top";
import {Link as ScrollLink, Scroll} from "react-scroll";
import {useMediaQuery} from "react-responsive";
import Article from "@/Components/Article";
import GraphS1 from "@/Components/Front/Graphs/GraphS1";
import GraphS2 from "@/Components/Front/Graphs/GraphS2";
import GraphS3 from "@/Components/Front/Graphs/GraphS3";
import {Pagination} from "swiper";
import FadeWrapper from "@/Components/Front/FadeWrapper";
import ZoomWrapper from "@/Components/Front/ZoomWrapper";
import Consent from "@/Components/Front/Consent";


export default function Index(props) {
    const [currentActiveSection, setCurrentActiveSection] = React.useState(null);
    const [lang, setLang] = useLang(props.locale);
    const [activeItem, setActiveItem] = React.useState("index");
    const wwdRef = useRef(null);
    const impactRef = useRef(null);
    const servicesRef = useRef(null);
    const teamRef = useRef(null);
    const isMobile = useMediaQuery({query: '(max-width: 639px)'});
    const isSm = useMediaQuery({query: '(min-width: 640px)'})
    const isMd = useMediaQuery({query: '(min-width: 768px)'})
    const isXl = useMediaQuery({query: '(min-width: 1366px)'})
    const is2Xl = useMediaQuery({query: '(min-width: 1800px)'})
    const is3Xl = useMediaQuery({query: '(min-width: 2400px)'})


    const [postLoaded, setPostLoaded] = React.useState(false);

    const textProps = {
        lang: lang, language: props.language,
    };

    const handleActiveSection = (section) => {
            console.log(currentActiveSection, section)
            if (section !== currentActiveSection) {
                console.log("in")

                setCurrentActiveSection(section);
            } else {
                console.log("out")
            }
        }
    ;

    return (<>
            {/*<Head>*/}
            {/*    <title>Datatherapy</title>*/}
            {/*</Head>*/}
            <ScrollToTop smooth component={<ArrowDown/>} style={{

                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                background: "#331083",
                borderRadius: '100%',
                transform: "rotate(180deg)",
                boxShadow: "0px 0px 0px #000",
                width: "3.75rem",
                height: "3.75rem",
            }}/>


            <Header textProps={textProps} locale={lang} language={props.language} setLang={setLang}
                    activeItem={'index'} setCurrentActiveSection={handleActiveSection}/>
            <section className="hero">

                {isSm &&

                    <Ratio ratio={1.29 / 1} className={"rive-container"}>
                        <Rive src="assets/hero-flow-right-slow.riv"
                              layout={new Layout({fit: Fit.Cover, alignment: Alignment.TopCenter})}
                        />

                    </Ratio>
                }


                <div className="in-frame">

                    <div className={"hero-content"}>

                        <h1 className="hero-title text-1"><Text {...textProps} str={"unleash"}/></h1>
                        <h1 className="hero-title text-2"><Text {...textProps} str={"the-power"}/></h1>
                        <h1 className="hero-title text-3"><Text {...textProps} str={"of-data"}/></h1>
                        <h3 className="hero-subtitle">
                            <FadeWrapper>

                                <Text {...textProps} str={"hero-text"}/>
                            </FadeWrapper>
                        </h3>
                        <div className="hero-action">
                            <FadeWrapper>
                                <ScrollLink to={"what-we-do"} spy smooth>
                                    <button className={"btn"} href="/testpage" role={"button"}>
                                        <Text {...textProps} str={"hero-action"}/></button>
                                </ScrollLink>

                            </FadeWrapper>


                        </div>
                    </div>

                </div>
                {isSm &&

                    <div className={"graph2-container"}>

                        <Graph2/>
                    </div>
                }

            </section>

            <section id="what-we-do" ref={wwdRef}>
                {isMobile &&

                    // <Ratio ratio={1/ 1} className={"rive-container mobile-rive"}>

                    <Rive src="assets/dt-hero-small.riv" className={"mobile-rive"}
                          layout={new Layout({fit: Fit.FitWidth, alignment: Alignment.CenterLeft})}
                    />

                    // </Ratio>
                }
                {isSm &&

                    <div className={"graph4-container"}>

                        <Graph4/>
                    </div>
                }
                {isMobile &&

                    <div className={"graph-s-1-container"}>

                        <GraphS1/>

                    </div>
                }

                <div className={'section-background'}>
                    {/*<DarkPlanet/>*/}
                    <img src={DarkPlanet} alt=""/>
                </div>
                <div className={"in-frame-inner"}>

                    <FadeWrapper bottom opposite className={'top'}>
                        <div className={"what-we-do"}>
                            <h1><Text {...textProps} str={'what-we-do'}/></h1>
                            <p><Text {...textProps} str={'what-we-do-text'}/></p>
                        </div>
                    </FadeWrapper>

                    <FadeWrapper offset={'50vh'} opposite>
                        <div className="dot"><span></span></div>
                    </FadeWrapper>

                    <div className={"rwd"}>
                        <h1><Text {...textProps} str={"real-word-data"}/></h1>
                        <p>
                            <Text {...textProps} str={"real-word-data-text"}/>
                        </p>
                    </div>

                    <div className={"step-1-container"}>
                        <ZoomWrapper>
                            <Step1/>
                        </ZoomWrapper>

                    </div>
                    {isMobile &&

                        <div className={"graph-s-2-container"}>

                            <GraphS2/>
                        </div>
                    }
                </div>
            </section>
            <section id={"processing"}>

                <div className={"middle"}>


                    <div className={"available-data"}>
                        <h1><Text {...textProps} str={"available-data"}/></h1>
                        <p>
                            <Text {...textProps} str={"available-data-text"}/>
                        </p>

                    </div>
                    <div className={"data-generation"}>
                        <h1><Text {...textProps} str={"data-generation"}/></h1>
                        <p>
                            <Text {...textProps} str={"data-generation-text"}/>
                        </p>
                        <Link href={"services-registry-program-design"} className={"data-generation-button"}>

                            <div className={"dt-button pink"}>

                            <span>
                            <Text {...textProps} str={"ver-mas"}/>
                            </span>
                            </div>

                        </Link>
                    </div>
                </div>
                {isMobile &&

                    <div className={"graph-s-3-container"}>

                        <GraphS3/>
                    </div>
                }
                {isSm &&

                    <div className={"graph-container"}>
                        <Graph5/>
                    </div>

                }
                {isMobile &&
                    <div className={"mobile-processing"}>
                        <div className={"step2-container"}>
                            <ZoomWrapper>
                                <Step2/>
                            </ZoomWrapper>
                        </div>
                        <div className={'processing-container'}>
                            <h1><Text {...textProps} str={"processing"}/></h1>
                            <p>
                                <Text {...textProps} str={"processing-text"}/>
                            </p>
                        </div>
                    </div>

                }
                <div className={"middle processing"}>

                    {isSm &&

                        <div className={"available-data processing-item"}>
                            <div className={"step2-container"}>
                                <ZoomWrapper>
                                    <Step2/>
                                </ZoomWrapper>
                            </div>
                            <h1><Text {...textProps} str={"processing"}/></h1>
                            <p>
                                <Text {...textProps} str={"processing-text"}/>
                            </p>

                        </div>
                    }
                    <div className={"data-generation"}>
                        <h1></h1>
                        <p>

                        </p>
                    </div>
                </div>
                {isSm &&
                    <div className={"step-3-container"}>
                        <ZoomWrapper>

                            <Step3/>
                        </ZoomWrapper>


                    </div>
                }
                <div className={"real-world-evidence-container"}>
                    <div className={"filler"}>
                        {isMobile &&
                            <ZoomWrapper>

                                <Step3/>


                            </ZoomWrapper>
                        }


                    </div>
                    <div className={"rwe-graph"}>

                        <GraphColor line={2}/>

                    </div>
                    <div className={"real-world-evidence-info"}
                    >

                        <h1>
                                <span>
                                <Text {...textProps} str={"real"}/>
                                </span>
                            <span>
                                <Text {...textProps} str={"world"}/>
                                </span>
                            <span>
                                <Text {...textProps} str={"evidence"}/>
                                </span>
                        </h1>
                        <p>
                            <Text {...textProps} str={"real-word-evidence-text"}/>

                        </p>


                    </div>

                </div>
                <div className={"impact-header"}>
                    <h1><Text {...textProps} str={"impact-part"}/> <span><Text {...textProps} str={"rwe"}/>  </span>
                        <Text {...textProps} str={"in-the-health-ecosystem"}/>
                    </h1>
                </div>
            </section>

            <FadeWrapper opposite>

                <section id="impact" className={"ba"} ref={impactRef}>
                    <div className={"in-frame-ba"}>

                        <DemoCreateEls textProps={textProps}/>
                    </div>

                </section>
            </FadeWrapper>
            <VisibilitySensor partialVisibility={true} offset={{top: 500}}>
                {({isVisible}) =>

                    <section id={"services"} className={isVisible ? "active " : ""} ref={servicesRef}>

                        <div className={'in-frame-inner'}>
                            <div className={"graph3-container"}>

                                <Graph3/>
                            </div>
                            <div className="services-header">
                                <div className={"dot-services"}>
                                <span className={"serv-target"}>
                                    {isSm &&
                                        <Circle/>
                                    }
                                </span>
                                </div>
                                <h1><Text {...textProps} str={"services"}/></h1>
                                <Bar/>
                            </div>

                            <div className={"services-container"}>
                                <Swiper
                                    spaceBetween={10}
                                    slidesPerView={1}
                                    pagination={true}
                                    modules={[Pagination]}


                                    breakpoints={{
                                        640: {
                                            slidesPerView: 2,
                                            spaceBetween: 10
                                        },
                                        1024: {
                                            slidesPerView: 3,
                                            spaceBetween: 15
                                        },
                                        1300: {
                                            slidesPerView: 3.3,
                                            spaceBetween: 15
                                        }
                                    }
                                    }
                                >

                                    < SwiperSlide className={"service-card"}>
                                        <div className={"overlay"}/>
                                        <Link href={"services-generation"}>
                                            <article>
                                                <div className={"services-header"}>
                                                    <div className={"services-icon"}>
                                                        <LineaGraph/>
                                                    </div>
                                                    <h1><Text {...textProps} str={'services-data-generation'}/></h1>
                                                </div>
                                                <div className="services-content">
                                                    <p>
                                                        <Text {...textProps} str={'services-data-generation-text'}/>
                                                    </p>

                                                </div>
                                                <div className={"services-footer"}>
                                                    {/*footer*/}
                                                </div>


                                            </article>
                                        </Link>
                                    </SwiperSlide>
                                    <SwiperSlide className={"service-card"}>
                                        <div className={"overlay"}/>

                                        <Link href={"services-available"}>
                                            <article className={""}>
                                                <div className={"services-header"}>
                                                    <div className={"services-icon"}>
                                                        <LineaData/>
                                                    </div>
                                                    <h1><Text {...textProps} str={'services-data-analysis'}/></h1>
                                                </div>
                                                <div className="services-content">
                                                    <p>
                                                        <Text {...textProps} str={'services-data-analysis-text'}/>
                                                    </p>

                                                </div>
                                                <div className={"services-footer"}>
                                                    {/*footer*/}
                                                </div>


                                            </article>
                                        </Link>

                                    </SwiperSlide>
                                    <SwiperSlide className={"service-card"}>
                                        <div className={"overlay"}/>

                                        <Link href={"services-database"}>

                                            <article className={""}>
                                                <div className={"services-header"}>
                                                    <div className={"services-icon"}>
                                                        <LineaDb/>
                                                    </div>
                                                    <h1><Text {...textProps} str={'services-database-analysis'}/></h1>
                                                </div>
                                                <div className="services-content">
                                                    <p>
                                                        <Text {...textProps} str={'services-database-analysis-text'}/>
                                                    </p>

                                                </div>
                                                <div className={"services-footer"}>
                                                    {/*footer*/}
                                                </div>


                                            </article>
                                        </Link>
                                    </SwiperSlide>

                                </Swiper>
                            </div>


                        </div>
                        {/*<div className={"background-arrows"}>*/}

                        {/*    <div className={isVisible ? "team-down active" : "team-down  "}>*/}
                        {/*        <TeamFlat/>*/}
                        {/*    </div>*/}
                        {/*    <div className={isVisible ? "team-up active" : "team-up "}>*/}
                        {/*        <TeamFlat/>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </section>
                }
            </VisibilitySensor>
            <VisibilitySensor partialVisibility={true} offset={{top: 500}}>
                {({isVisible}) =>

                    <section id="team" ref={teamRef} className={isVisible ? "active" : ""}>

                        <div className={'in-frame-inner'}>

                            <div className={"team-header"}>
                                <h1><Text {...textProps} str={'team-title'}/></h1>
                                <p><Text {...textProps} str={'team-text'}/></p>
                            </div>

                            <div className={"team-members"}>
                                <div className={"background-arrows"}>

                                    <div className={isVisible ? "team-down active" : "team-down  "}>
                                        <TeamFlat/>
                                    </div>
                                    <div className={isVisible ? "team-up active" : "team-up "}>
                                        <TeamFlat/>
                                    </div>
                                </div>
                                <div className={"member"}>
                                    <figure>
                                        <img src={Member1} alt={"member-1"}/>
                                    </figure>
                                    <div className={"member-info"}>
                                        <p><Text {...textProps} str={'team-member-1-text'}/></p>

                                        <h2><a target={"_blank"}
                                               href={textProps.language['es']['team-member-1-linkedin']}><Text {...textProps}
                                                                                                               str={'team-member-1-name'}/></a>
                                        </h2>
                                        <h3><Text {...textProps} str={'team-member-1-position'}/></h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                }
            </VisibilitySensor>

            <section id={"publications"}>
                <div className={"in-frame-inner"}>

                    <h1><Text {...textProps} str={"publications"}/></h1>
                    <div className={"color-bar"}>
                        <Bar/>

                    </div>


                    {postLoaded ?


                        <div className={"publications-container"}>
                            {props.publications.map((i, index) => {
                                return (
                                    <Article key={"publication--" + index} item={i} textProps={textProps} lang={lang}/>

                                )
                            })}
                        </div> :
                        <div>
                            {isMobile &&


                                <div className={"publications-container"}>

                                    {props.publications.filter((p, index) => index < 2).map((i, index) => {
                                        return (
                                            <Article key={"publication---" + index} item={i} textProps={textProps}
                                                     lang={lang}/>

                                        )
                                    })}
                                </div>
                            }
                            {isSm &&

                                <Swiper
                                    spaceBetween={50}
                                    slidesPerView={"auto"}

                                >
                                    {props.publications.map((i, index) => {
                                        return (
                                            <SwiperSlide key={"slide-publication-" + index}>
                                                <Article key={"publication---" + index} item={i} textProps={textProps}
                                                         lang={lang}/>


                                            </SwiperSlide>)
                                    })}
                                    <SwiperSlide key={"slide-publication-last"}></SwiperSlide>


                                </Swiper>
                            }

                            <div className={"load-more-container"}>

                                <div className={"load-more"} onClick={() => {
                                    setPostLoaded(true);
                                }}>


                                    <span><Text {...textProps} str={"load-all-posts"}/> </span>
                                </div>
                            </div>

                        </div>

                    }


                </div>
            </section>
            <section id={"sponsors"}>
                <div className={"in-frame-inner"}>

                    <h1><Text {...textProps} str={"in-collaboration-with"}/></h1>


                    <Swiper
                    // spaceBetween={50}
                    slidesPerView={"auto"}
                    centeredSlides={true}

                >

                    <SwiperSlide className={"sponsor-1"}>
                        <Sponsor1/>


                    </SwiperSlide>

                    <SwiperSlide key={"slide-publication-last"}></SwiperSlide>


                </Swiper>
                </div>


            </section>
            <Footer textProps={textProps}/>
            <Consent  textProps={textProps} />
        </>
    );
}
